import {defineSlotRecipe} from '@chakra-ui/react3'

export const colorSwatchesRecipe = defineSlotRecipe({
    slots: ['swatch', 'swatchInner', 'swatchImage', 'variationText'],
    base: {
        swatch: {
            borderRadius: 'round',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            _checked: {
                outline: '{borders.sm} {colors.border.brand}'
            },
            _focusVisible: {
                outline: '{borders.md} {colors.border.brand}'
            },
            _disabled: {
                cursor: 'not-allowed'
            },
            _unavailable: {
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    width: '1px',
                    // multiply the square size by √2 to get the diagonal length
                    // fallback to something meaningful based on the label size
                    height: 'calc(var(--disabled-line-size, 66%) * 1.4)',
                    background: 'black',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%) rotate(-45deg)',
                    pointerEvents: 'none'
                }
            }
        },
        swatchInner: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'round',
            overflow: 'hidden',
            flexShrink: 0
        },
        swatchImage: {
            overflow: 'hidden',
            objectFit: 'cover',
            display: 'block',
            width: '100%',
            height: '100%',
            position: 'relative',
            _after: {
                content: '""',
                position: 'absolute',
                inset: '0',
                border: 'sm',
                borderColor: 'border.subtle',
                borderRadius: 'round'
            }
        },
        variationText: {
            color: 'text.secondary'
        }
    },
    variants: {
        size: {
            18: {
                swatch: {
                    '--disabled-line-size': 'sizes.spacing-20',
                    width: 'spacing-26',
                    height: 'spacing-26',
                    margin: '-spacing-4',
                    _checked: {
                        outlineOffset: '-2px'
                    },
                    _focusVisible: {
                        outlineOffset: '-2px'
                    }
                },
                swatchInner: {
                    width: 'spacing-18',
                    height: 'spacing-18'
                }
            },
            26: {
                swatch: {
                    '--disabled-line-size': 'sizes.spacing-26',
                    width: 'spacing-36',
                    height: 'spacing-36',
                    margin: '-spacing-5',
                    _checked: {
                        outlineOffset: '-3px'
                    },
                    _focusVisible: {
                        outlineOffset: '-3px'
                    }
                },
                swatchInner: {
                    width: 'spacing-26',
                    height: 'spacing-26'
                }
            }
        }
    }
})
